module.exports = __webpack_public_path__ + "img/42_21.90eb2fff.png";